<template>
  <div class="width-100 height-100 max_box">
    <component
      :is="currentView"
      :cardData="cardData"
      ref="coms"
      @playEnd="playNext()"
    ></component>
  </div>
</template>
<script>
import $ from "jquery";
import { GetParams2 } from "../../utils/common";
import ApiServe from "@/api/index";
import OneComponent from "./one.vue";
import TwoComponent from "./two.vue";
export default {
  name: "guojun",
  components: {
    OneComponent,
    TwoComponent,
  },
  data() {
    return {
      audioSrcList: [],
      audioTimeList: [],
      device_id: null,
      recordtimeAll: null,
      id: "",
      model_id: null,
      model_name: "",
      model_category: "",
      url_extra_params: null,
      ip: "",
      port: "",
      offset_x: "",
      offset_y: "",
      width: "",
      height: "",
      source: "",
      audioData: [],
      currentIndex: 1,
      aduioData: [], //旁白的数据
      cardData: {},
    };
  },
  created() {
    this.id = GetParams2().id || null;
    this.model_id = GetParams2().model_id || 1;
    this.model_name = GetParams2().model_name || null;
    this.model_category = GetParams2().model_category || null;
    this.url_extra_params = GetParams2().url_extra_params || null;
    this.ip = GetParams2().ip || null;
    this.port = GetParams2().port || null;
    this.offset_x = GetParams2().offset_x || null;
    this.offset_y = GetParams2().offset_y || null;
    this.width = GetParams2().width || null;
    this.height = GetParams2().height || null;
    this.source = GetParams2().source || null;
  },
  computed: {
    newIpPort() {
      if (this.source == "ali") {
        return "https://recordvideoali.wedengta.com";
      } else {
        return "https://recordvideo.wedengta.com";
      }
    },
    currentView() {
      if (this.currentIndex == 1) {
        return OneComponent;
      }
      if (this.currentIndex == 2) {
        return TwoComponent;
      }

      return OneComponent;
    },
  },
  async mounted() {
    if (this.ip && this.port) {
      console.log(666);
      const params = {
        ip: this.ip,
        port: this.port,
        offset_x: this.offset_x,
        offset_y: this.offset_y,
        width: this.width,
        height: this.height,
      };
      ApiServe.recordstartPc(this.newIpPort, params)
        .then(({ code }) => {
           this.load();
        })
        .catch((err) => {
          ApiServe.recordreleasePc(this.newIpPort, {
            ip: this.ip,
            port: this.port,
          });
        });
     
    } else {
      // alert("没获取到ip,port");
      this.load();
    }
  },
  methods: {
    endRecord() {
      this.aduioData = [
        {
          audioLink:
            "https://res.idtcdn.com/Cube/video-config/con-dde64353.mp3",
          timeIndex: 0,
          audioLen: 13,
        },
        {
          audioLink:
            "https://res.idtcdn.com/Cube/video-config/con-2ef072b1.mp3",
          timeIndex: 15,
          audioLen: 4,
        },
        {
          audioLink:
            "https://res.idtcdn.com/Cube/video-config/con-b2397e7d.mp3",
          timeIndex: 20,
          audioLen: 3,
        },
        {
          audioLink:
            "https://res.idtcdn.com/Cube/video-config/con-4e8d6f5d.mp3",
          timeIndex: 24,
          audioLen: 6,
        },
        {
          audioLink:
            "https://res.idtcdn.com/Cube/video-config/con-d82be178.mp3",
          timeIndex: 32,
          audioLen: 3,
        },
        {
          audioLink:
            "https://res.idtcdn.com/Cube/video-config/con-f7e05987.mp3",
          timeIndex: 41,
          audioLen: 3,
        },
        {
          audioLink:
            "https://res.idtcdn.com/Cube/video-config/con-46c3ee76.mp3",
          timeIndex: 47,
          audioLen: 3,
        },
        {
          audioLink:
            "https://res.idtcdn.com/Cube/video-config/con-dc8e8db8.mp3",
          timeIndex: 55,
          audioLen: 5,
        },
        //fang
         {
          audioLink:
            "https://res.idtcdn.com/Cube/video-config/con-c56c0909.mp3",
          timeIndex: 62,
          audioLen: 5,
        },
         {
          audioLink:
            "https://res.idtcdn.com/Cube/video-config/con-1da42ed0.mp3",
          timeIndex: 70,
          audioLen: 9,
        },
          {
          audioLink:
            "https://res.idtcdn.com/Cube/video-config/con-09382d69.mp3",
          timeIndex: 82,
          audioLen: 7,
        },
         {
          audioLink:
            "https://res.idtcdn.com/Cube/video-config/con-5ed21aca.mp3",
          timeIndex: 92,
          audioLen: 9,
        },
         {
          audioLink:
            "https://res.idtcdn.com/Cube/video-config/con-f2259908.mp3",
          timeIndex: 102,
          audioLen: 9,
        },
         {
          audioLink:
            "https://res.idtcdn.com/Cube/video-config/con-6c5734ba.mp3",
          timeIndex: 112,
          audioLen: 8,
        },
      ];
      const data = {
        id: this.id,
        model_id: this.model_id,
        videoTotalTime: 122,
        videmBgm: "https://res.idtcdn.com/Cube/video-config/con-ec094cc4.mp3",
        audiosOrderList: this.aduioData,
      };
      ApiServe.recordstopPc(this.newIpPort, { ip: this.ip, port: this.port })
        .then(() => {
          ApiServe.combineaudioswithbgm(
            this.newIpPort,
            this.ip,
            this.port,
            data
          )
            .then(() => {
              ApiServe.recordreleasePc(this.newIpPort, {
                ip: this.ip,
                port: this.port,
              });
            })
            .catch(() => {
              ApiServe.recordreleasePc(this.newIpPort, {
                ip: this.ip,
                port: this.port,
              });
            });
        })
        .catch(() => {
          ApiServe.recordreleasePc(this.newIpPort, {
            ip: this.ip,
            port: this.port,
          });
        });
    },
    // 页面card一个接一个播放
    async load() {
      // this.$refs.bgAudio.volume = 0.1;
      // this.$refs.bgAudio.play();
      this.$refs.coms.playCardStart();

      // 总时间 94 + 3秒
      if (this.ip) {
        setTimeout(() => {
          this.endRecord();
        }, (70+52)*1000);
      }
    },
    playNext() {
      this.currentIndex++;
      this.$nextTick(() => {
        this.$refs.coms.playCardStart();
      });
    },
  },
};
</script>
<style scoped lang="less">
@import "./index.less";
</style>